import SettingsEmailRulesSubPage from "./settings-email-rules-sub-page";
import SettingsCountersSubPage from "./settings-counters-sub-page";
import SettingsAppSubPage from "./settings-app-sub-page";


const SubPage = {
    App: SettingsAppSubPage,
    EmailRules: SettingsEmailRulesSubPage,
    Counters: SettingsCountersSubPage
};

export default SubPage;
